import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, DatePicker } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { dateFormatIG } from '../IGconfig';
dayjs.extend(customParseFormat);

const DateSelector = ({ value: date, onChange: setDate }) => {
  const hasDate = date != null && String(date).trim() !== '';
  const baseDate = hasDate ? dayjs(date, dateFormatIG) : dayjs();

  const prevDayClicked = () => setDate(baseDate.subtract(1, 'day').format(dateFormatIG));
  const nextDayClicked = () => setDate(baseDate.add(1, 'day').format(dateFormatIG));
  const todayClicked = () => setDate(null);

  return (
    <span className="flex items-center gap-2">
      <DatePicker
        value={hasDate ? dayjs(date, dateFormatIG) : null}
        format={dateFormatIG}
        placeholder="Today"
        onChange={(_, dateString) => setDate(dateString ?? null)}
        allowClear={false}
      />
      <Button onClick={prevDayClicked}><LeftOutlined /></Button>
      <Button onClick={nextDayClicked}><RightOutlined /></Button>
      <Button onClick={todayClicked}>Today</Button>
    </span>
  )
}

export default DateSelector
